// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainContainer_mainContainer__X-94J"};